<!-- Simge Grubu -->
<div style="display: flex;">
    <button class="ui icon mini button"
            style="padding: 0.2rem;"
            [class.yellow]="analizTipi=='DraftAngle'"
            (click)="analizTipi='DraftAngle';CD.detectChanges();"
            title="Ters Açı Analizi">
        <i class="icon chart area"
           style="width: 16px !important; height: 16px;font-size: 15px;"></i>
    </button>

    <button class="ui icon mini button"
            style="padding: 0.2rem;"
            [class.yellow]="analizTipi=='Undercut'"
            (click)="analizTipi='Undercut';CD.detectChanges();"
            title="Undercut Tespiti">
        <i class="icon angle double down"
           style="width: 16px !important; height: 16px;font-size: 15px;"></i>
    </button>

    <button class="ui icon mini button"
            style="padding: 0.2rem;"
            [class.yellow]="analizTipi=='DuvarKalinlik'"
            (click)="analizTipi='DuvarKalinlik';CD.detectChanges();"
            title="Duvar Kalınlık Analizi">
        <i class="icon arrows alternate horizontal"
           style="width: 16px !important; height: 16px;font-size: 15px;"></i>
    </button>
</div>

<div class="ui divider"
     style="margin-top: 0.1rem;margin-bottom:0.1rem;"></div>

<!-- Draft Angle Modu -->
<fikoyt-draft-angle #FikoYTDraftAngle
                    [style.display]="analizTipi=='DraftAngle' ? 'block':'none'"
                    [anaGosterim]="anaGosterim">
</fikoyt-draft-angle>

<!-- Undercut Modu -->
<fikoyt-undercut #FikoYTUndercut
                 [style.display]="analizTipi=='Undercut' ? 'block':'none'"
                 [anaGosterim]="anaGosterim">
</fikoyt-undercut>

<!-- Duvar Kalınlık Modu -->
<fikoyt-wall-thickness #FikoYTWallThickness
                       [style.display]="analizTipi=='DuvarKalinlik' ? 'block':'none'"
                       [anaGosterim]="anaGosterim">
</fikoyt-wall-thickness>

<div class="ui divider"
     style="margin-top: 0.3rem;margin-bottom:0.3rem;"></div>

<!-- <div style="display: flex;align-items: center;">
    <div class="ui animated mini button"
         tabindex="0"
         style="padding: 0.5rem;margin-left: auto;"
         (click)="kapa()">
        <div class="visible content">Kapat</div>
        <div class="hidden content">
            <i class="check icon"></i>
        </div>
    </div>
</div> -->
